import React from "react";
import Marty from "marty";

let App404 = React.createClass({
    componentWillMount() {
        if (Marty.isBrowser) {
            document.title = "eero - Oops...";
        }
    },
    render() {
        return (
            <section className="eo-view app-404">
                <div className="eo-error-content">
                    <div className="eo-error-text-container grid-5 push-m-5 push-l-5 push-xl-5 grid-s-10">
                        <div className="eo-error-text">
                            <div className="eo-error-text-header">
                                <h1 className="big-text"><strong>404!</strong></h1>
                                <h2 className="not-found">PAGE NOT FOUND</h2>
                            </div>
                            <p className="oops">Oops. Looks like something went wrong.</p>
                        </div>
                    </div>

                    <div className="eo-error-image-container grid-5 pull-m-5 pull-l-5 pull-xl-5 grid-s-10" >
                        <img className="eo-error-image" align="right" src="/public/img/404/product.png"/>
                    </div>
                </div>
            </section>
        );
    },
    getInitialState() {
        return {};
    }
});

export default Marty.createContainer(App404, {});



/** WEBPACK FOOTER **
 ** ./app/views/NotFound.js
 **/